import { FetchMonitorBasePlugin, FETCH_MONITOR_PLUGIN_NAME } from '@slardar/sdk-web';
export var FETCH_INTEGRATION_NAME = FETCH_MONITOR_PLUGIN_NAME;
export var fetchPlugin = function (config) {
    if (config === void 0) { config = {}; }
    return ({
        name: FETCH_INTEGRATION_NAME,
        setup: function (client) {
            FetchMonitorBasePlugin(client, config);
        },
    });
};
//# sourceMappingURL=fetch.js.map